import axios from '../axios';

export default {
  loadAllControllers (options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/controller?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getSipStatus: (id) => axios.put(`/controller/${id}/status`),
  newController (params) {
    return new Promise((resolve, reject) => {
      axios.post('/controller', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getController (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/controller/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getControllerInfoEdit (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/controller/${id}/edit`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateController (id, params) {
    return new Promise((resolve, reject) => {
      axios.put(`/controller/${id}`, params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  removeController (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/controller/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  openDorController (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/controller/${id}/open`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
